
import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Camera, HandMetal } from "lucide-react";

type InstallTutorialModalProps = {
  open: boolean;
  onClose: () => void;
};

export const InstallTutorialModal: React.FC<InstallTutorialModalProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="max-w-md mx-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Camera className="h-6 w-6 text-bauhaus-green" />
            Add Foto Fight to Home Screen
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <ul className="space-y-3 mt-3 text-base">
            <li>
              1. Tap the <span className="inline-block bg-gray-200 px-2 py-1 rounded font-semibold">Share</span> button <span role="img" aria-label="Share">🔗</span> in your browser.
            </li>
            <li>
              2. Scroll and select <span className="inline-block bg-gray-200 px-2 py-1 rounded font-semibold">Add to Home Screen</span>.
            </li>
            <li>
              3. Tap <b>Add</b> on the top right. That’s it!
            </li>
          </ul>
          <div className="mt-4 flex justify-center">
            <img src="/lovable-uploads/44456875-d314-40de-8012-201a5622c18c.png" alt="App icon" className="h-16 w-16 rounded-lg shadow" />
          </div>
        </DialogDescription>
        <div className="flex justify-end mt-6">
          <DialogClose asChild>
            <Button variant="default" onClick={onClose}>
              OK, Got it!
              <HandMetal className="ml-2 h-4 w-4" />
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};
